import 'modernizr'; // eslint-disable-line
import 'lazysizes';
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import header from '../modules/header';
import toTop from '../modules/toTop';
import videoOverlay from '../modules/videoOverlay';
import videoElement from '../modules/videoElement';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import datepicker from '../modules/datepicker';
import daterangepicker from '../modules/daterangepicker';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import controlledInput from '../modules/controlledInput';
import map from '../modules/map';
import navigation from '../modules/navigation';
import slideCounter from '../modules/slideCounter';
import filter from '../modules/filter/filter';
import readMore from '../modules/readMore';
import webshopForm from '../modules/webshopForm';
import mediaSlider from '../modules/mediaSlider';
import toggleContent from '../modules/toggleContent';
// import gaTracking from '../modules/gaTracking';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  header.initialize();
  toTop.initialize();
  videoOverlay.initialize();
  videoElement.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  datepicker.initialize();
  daterangepicker.initialize();
  embedWrap();
  whatsapp.initialize();
  alert.initialize();
  mediaRow.initialize();
  controlledInput.initialize();
  map.initialize();
  navigation.initialize();
  slideCounter.initialize();
  filter.initialize();
  readMore.initialize();
  webshopForm.initialize();
  mediaSlider.initialize();
  toggleContent.initialize();
  // gaTracking();
  porta({
    messages: nl,
  });
  document.addEventListener('lazybeforeunveil', (e) => {
    const bg = e.target.getAttribute('data-bg');
    if (bg) {
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });
};

export default general;
